<template>
    <div>
        <p>V vaš profil je povezana kartica številka <b>{{ card_number }}</b>. Če želite lahko odstranite kartico iz obstoječega
            profila in dodate drugo.</p>
        <v-btn class="noBtnMargin" depressed @click="doRemoveCard">Odstrani kartico s profila</v-btn>
        <v-dialog
                v-model="dialog"
                persistent
                max-width="390"
        >
            <v-card>
                <v-card-title class="headline">
                    Ali res želite odstranitev kartice iz vašega profila?
                </v-card-title>
                <v-card-text>
                    Z odstranitvijo kartice iz vašega profila ne bo več možno urejanje kartice številka <b>{{ card_number }}</b>.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red darken-1"
                            text
                            @click="cancel()"
                    >
                        Prekliči
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="confirm"
                            :loading="loadingDisconnect"
                    >
                        DA, odstrani
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {userService} from "../../../services";
    import utils from "../../../store/utils";

    export default {
        name: "DisconnectCard",
        data() {
            return {
                dialog: false,
                loadingDisconnect: false
            }
        },
        computed: {
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            card_number: utils.vuexBuildSetGet(this, 'profile', 'user.card'),
        },
        methods: {
            cancel() {
                this.dialog = false;
            },
            confirm() {
                this.loadingDisconnect = true;
                userService.disconnectCard().then(() => {
                    window.location.replace('/');
                }, (error) => {
                    window.location.replace('/');
                }).finally(() => {
                    this.loadingDisconnect = false;
                });
            },
            doRemoveCard() {
                this.dialog = true;
            }
        }
    }
</script>

<style scoped>

</style>